import { render, staticRenderFns } from "./warningKBgvKorM3.vue?vue&type=template&id=551879cf"
import script from "./warningKBgvKorM3.vue?vue&type=script&lang=js"
export * from "./warningKBgvKorM3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports